module.exports = __webpack_public_path__ + "static/media/JawaidWali(F)(B).9653185a.jpeg";